// VAPI_SCHEMA v1 - Keep identical to supabase/functions/_shared/vapiEvent.ts
import { z } from 'zod';

export const VapiEventSchema = z.object({
  type: z.literal('assistant-tool-call'),
  call: z.object({
    id: z.string(),
    metadata: z.object({
      userId: z.string(),
      campaignId: z.string(), 
      prospectId: z.string(),
      prospectLabel: z.string(),
    }),
  }),
  data: z.object({
    toolName: z.string(),
    args: z.record(z.string(), z.any()),
  }),
  event_id: z.string().uuid(),
});

export type VapiEvent = z.infer<typeof VapiEventSchema>;
